export const environment = {
  production: true,
  version: require("../../package.json").version,
  apiUrl: "https://workpass.baguio.gov.ph/api",
  firebase: {
    projectId: "workpass-production",
    appId: "1:650816047468:web:2bdc877dddf95dc9260b49",
    storageBucket: "workpass-production.appspot.com",
    apiKey: "AIzaSyAyzmsnfYYnkhXSj5K1Hi3o9rLVJXRVAQc",
    authDomain: "workpass-production.firebaseapp.com",
    messagingSenderId: "650816047468",
    measurementId: "G-7PC8P3Z8VS",
  },
};
